import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import UploadForm from '../components/UploadForm';
import Guestbook from '../components/Guestbook';
import { getWeddingByCode } from '../services/apiService';
import '../upload.css';

// --- İKONLAR ---
const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
);


const DEFAULT_ALBUM_COVER = 'https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&q=80&w=300';

const uploadedByEmail = 'misafir@example.com';

export default function UploadOnlyPage() {
    const { code } = useParams();

    const [weddingId, setWeddingId] = useState(null);
    const [weddingInfo, setWeddingInfo] = useState(null);
    const [resolving, setResolving] = useState(true);
    const [resolveError, setResolveError] = useState('');
    const [isGuestbookOpen, setIsGuestbookOpen] = useState(false);
    const [selectedAlbum, setSelectedAlbum] = useState('default');
    const [caption, setCaption] = useState('');

    // Bu sayfada isOwner hep false.
    const isOwner = false;

    // Tema Uygulama
    useEffect(() => {
        if (weddingInfo && weddingInfo.theme) {
            document.body.setAttribute('data-theme', weddingInfo.theme);
        } else {
            document.body.removeAttribute('data-theme');
        }
    }, [weddingInfo]);

    // Düğün Bilgilerini Çekme
    useEffect(() => {
        if (!code) {
            setResolving(false);
            setResolveError('Bu sayfa sadece QR ile açılır.');
            return;
        }
        let cancelled = false;
        setResolving(true);
        setWeddingId(null);
        setWeddingInfo(null);
        (async () => {
            try {
                const { wedding } = await getWeddingByCode(code);
                if (!cancelled) {
                    if (wedding?._id) {
                        // ✅ GÜVENLİK KONTROLÜ: URL'deki kod ile gelen düğün kodu eşleşiyor mu?
                        if (wedding.code !== code) {
                            console.error("Kod çakışması tespit edildi!", { url: code, db: wedding.code });
                            setResolveError('Bir bağlantı hatası oluştu. Lütfen sayfayı yenileyip tekrar deneyin.');
                            return;
                        }

                        setWeddingId(wedding._id);
                        setWeddingInfo(wedding);

                        if (wedding.albumMode !== 'default' && wedding.albumNames?.length > 0) {
                            setSelectedAlbum(wedding.albumNames[0]);
                        } else {
                            setSelectedAlbum('default');
                        }
                    } else {
                        setResolveError('Kod geçersiz veya düğün bulunamadı.');
                    }
                }
            } catch {
                if (!cancelled) setResolveError('Kod çözümlenemedi (ağ/erişim).');
            } finally {
                if (!cancelled) setResolving(false);
            }
        })();
        return () => { cancelled = true; };
    }, [code]);

    const handleNewUpload = () => {
        console.log("Misafir tarafından fotoğraf yüklendi.");
    };

    if (resolving) return <div className="wedding-page">Kapak Fotoğrafı Yükleniyor…</div>;
    if (resolveError) return <div className="wedding-page">{resolveError}</div>;
    if (!weddingId) return <div className="wedding-page">Bu sayfa sadece QR ile açılır.</div>;

    const showAlbumSelector = weddingInfo?.albumMode !== 'default' && weddingInfo?.albumNames?.length > 0;

    return (
        <div className="wedding-page">

            {/* ÜST YÖNETİM ŞERİDİ (İsim burada görünecek) */}
            <div className="top-header-bar" style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '14px 20px',
                textAlign: 'center'
            }}>
                <span style={{ fontWeight: 600, fontSize: '1.2rem', letterSpacing: '0.5px' }}>
                    {weddingInfo?.name || 'Fotoğraf Yükleme'}
                </span>
            </div>

            {/* --- HERO (KAPAK) BÖLÜMÜ --- */}
            <div
                className="hero-section"
                style={{
                    backgroundImage: weddingInfo?.heroImageUrl
                        ? `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${weddingInfo.heroImageUrl})`
                        : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            >
                {/* ✅ DEĞİŞİKLİK BURADA: Kapak fotoğrafı üzerindeki yazılar kaldırıldı. Sadece temiz resim kaldı. */}
            </div>

            <main>
                <section className="photo-section">

                    {/* --- ALBÜM SEÇİM KARTLARI (WeddingPage ile Eşleşti) --- */}
                    {showAlbumSelector && (
                        <div className="album-nav-container">
                            {weddingInfo.albumNames.map((albumName, index) => { // index'i aldık!
                                const isActive = selectedAlbum === albumName;

                                // Owner sayfasında olduğu gibi, ana hero image kullanılıyor.
                                const bgImage = weddingInfo?.heroImageUrl || DEFAULT_ALBUM_COVER;

                                return (
                                    <div
                                        key={albumName}
                                        className={`album-card ${isActive ? 'active' : ''}`}
                                        onClick={() => setSelectedAlbum(albumName)}
                                    >
                                        <img
                                            src={bgImage}
                                            alt={albumName}
                                            className="album-card-bg"
                                        />
                                        <div className="album-card-overlay">
                                            <span className="album-card-title">{albumName}</span>
                                        </div>
                                        <div className="album-card-icon">
                                            <CheckIcon />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Başlık ve Açıklama */}
                    <div style={{ textAlign: 'center', marginBottom: '20px', padding: '0 20px' }}>
                        <h2 className="section-title">Anılarını Paylaş</h2>
                        <p style={{ color: '#666' }}>
                            {selectedAlbum !== 'default' ? `${selectedAlbum} albümü için f` : 'F'}otoğraf ve videolarını yükle, düğün sahibi onlara galerisinden erişsin.
                        </p>
                    </div>

                    {/* UploadForm */}
                    <div className="upload-container">
                        <UploadForm
                            onUpload={handleNewUpload}
                            weddingId={weddingId}
                            uploadedByEmail={uploadedByEmail}
                            uploadsLocked={!!weddingInfo?.uploadsLocked}
                            album={selectedAlbum}
                            caption={caption}
                            setCaption={setCaption}
                            isOwner={false}
                        />
                    </div>
                </section>

                <div style={{ textAlign: 'center', margin: '2rem 0' }}>
                    <button
                        onClick={() => setIsGuestbookOpen(true)}
                        className="open-modal-btn"
                    >
                        Bir Mesaj Bırakın
                    </button>
                </div>

                <Guestbook
                    weddingId={weddingId}
                    isOwner={isOwner}
                    weddingInfo={weddingInfo}
                    isOpen={isGuestbookOpen}
                    onClose={() => setIsGuestbookOpen(false)}
                />

                <div className="notice-card">
                    <p>
                        Bu düğünün galerisi <b>sadece düğün sahibine</b> görünür. Düğün sahibi iseniz
                        <Link to="/owner/login"> giriş yapın</Link>.
                    </p>
                </div>
            </main>
        </div>
    );
}